// 用户
import { $post, $get, $delete } from '@/utils/http'
import Service from './Service'

const USER = "/ucenter/v2/users"

// 用户登录
Service.login = async function (params) {
    let request = {}
    // 用户名
    request['username'] = params.username;
    // 密码
    request['password'] = params.password;
    // 密码
    request['value'] = params.value;
    // 密码
    request['captchaId'] = params.captchaId;
    let data = await $post(USER + "/login", request);
    return Service.handleCommonError(data)
}

// 用户退出
Service.logout = async function () {
    let request = {}
    let data = await $post(USER + "/logout", request);

    return Service.handleCommonError(data)
}

// 获取用户信息
Service.userInfo = async function () {
    let request = {}
    let data = await $get(USER + "/getaccountprofile", request);
    return Service.handleCommonError(data)
}


// 获取验证码
Service.getCaptcha = async function () {
    let request = {}
    let data = await $get("/ucenter/v2/captcha", request);
    return Service.handleCommonError(data)
}

// 权限账号管理
// 获取用户的列表
Service.getAccountList = async function (params) {
    let request = {}

    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 查询的用户类型 2：工程师账号，3：公司主账号，4：公司子账号
    request['usertype'] = params.usertype;
    // 	第几页
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;
    
    let data = await $get(USER + "", request);
    return Service.handleCommonError(data)
}

// 超级管理员获取公司账号列表
Service.getAdminAccountList = async function (params) {
    let request = {}

    // 查询的用户类型  1：超级管理员，2：工程师账号，3：公司主账号，
    request['usertype'] = params.usertype;
    // 	第几页
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;

    let data = await $get(USER + "", request);
    return Service.handleCommonError(data)
}

// 添加用户
Service.AddAccount = async function (params) {
    let request = {}

    // 用户名
    request['username'] = params.username;
    // 	密码
    request['password'] = params.pwd;
    // 	姓名
    request['name'] = params.name;
    // 用户组
    request['group'] = params.group;
    // 手机号码
    request['mobile'] = params.mobile;
	// 邮箱
	request['email'] = params.email;
    // 账号使用情况
    request['enable'] = params.enable;
    // 企业LOGO
    request['company_logo'] = params.company_logo;
    // 账号使用人的信息（姓名或者公司名称）
    request['user'] = params.user;
    // 备注（账号的职责描述）
    request['description'] = params.description;
    // 查询的用户类型  1：超级管理员，2：工程师账号，3：公司主账号，4：公司子账号
    request['usertype'] = params.usertype;
    // 账号管理项目组（针对公司子账号）
    request['project_id_json'] = params.project_id_json;

    let data = await $post('/ucenter/v2/users', request);
    return Service.handleCommonError(data)
}

// 修改
Service.editAccount = async function (params) {
    let request = {}

    // 用户OID
    request['oid'] = params.oid;
    // 用户组
    request['group'] = params.group;
    // 	姓名
    request['name'] = params.name;
    // 手机号码
    request['mobile'] = params.mobile;
	// 邮箱
	request['email'] = params.email;
    // 账号使用情况
    request['enable'] = params.enable;
    // 企业LOGO
    request['company_logo'] = params.company_logo;
    // 账号使用人的信息（姓名或者公司名称）
    request['user'] = params.user;
    // 备注（账号的职责描述）
    request['description'] = params.description;
    // 查询的用户类型  1：超级管理员，2：工程师账号，3：公司主账号，4：公司子账号
    request['usertype'] = params.usertype;
    // 账号管理项目组（针对公司子账号）
    request['project_id_json'] = params.project_id_json;

    let data = await $post('/ucenter/v2/users/update', request);
    return Service.handleCommonError(data)
}

// 修改密码
Service.editPwd = async function (params) {
    let request = {}

    // 用户OID
    request['oid'] = params.oid;
    // 密码 sha512加密
    request['password'] = params.password;

    let data = await $post(USER + '/updatepwd', request);
    return Service.handleCommonError(data)
}

// 删除用户
Service.delAccount = async function (params) {
    
    var formData = new FormData();
    formData.append("oid", params.oid);

    let data = await $delete(USER + '', formData);
    return Service.handleCommonError(data)
}
// 绑定邮箱
Service.bindEmail = async function (params) {
    let request = {}

    // 用户OID
    request['email'] = params.email;
    // 密码 sha512加密
    request['captcha_code'] = params.captcha_code;

    let data = await $post('/ucenter/v2/users/bindemail', request);
	return Service.handleCommonError(data)
}
 //获取验证码
 Service.getEmailcode = async function (params) {
     let request = {}
     request['email'] = params.email;
     let data = await $get("/ucenter/v2/email/captcha", request);
     return Service.handleCommonError(data)
 }
 // 解除绑定
 Service.unbindEmail = async function (params) {
     let request = {}
     let data = await $post('/ucenter/v2/users/unbindemail', request);
 	return Service.handleCommonError(data)
 }